import styled from 'styled-components';

const StyledBoxIndustries = styled.div`
  position: relative;
  width: 33.33%;
  text-align: left;
  .box--industries-wrap{
    position: relative;
  }
  .box--title{
    margin-bottom: 16px;
  }
  .box--text{
    color: ${props => props.theme.colors.grey_700};
  }
  .box--anchor{
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #003D2B;
  }
  .box--anchor-line{
    position: absolute;
    border: 1px solid #BAB9B5;
  }
  @media screen and (max-width: 1023px){
    .box--anchor, .box--anchor-line{
      display: none;
    }
  }
`;

export {
  StyledBoxIndustries,
};

